module.exports = __webpack_public_path__ + "static/media/Artboard6.086c4cf4.png";